import { createContext } from 'react';

const ExpensesContext = createContext({})

export  {ExpensesContext}
